import React from "react";

import { Props } from "./types";
import { RemoveIcon } from "./removeIcon";
import styles from "./styles.scss";

function isColorLight(color: string) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substring(0, 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

  return brightness > 155;
}

function ProjectPortfolioTag({ name, color, isRemovable, remove }: Props) {
  return (
    <div className={styles.tag} style={{ backgroundColor: color }}>
      <p
        className={styles.name}
        style={{
          color: isColorLight(color) ? "#000000" : "#FFFFFF",
        }}
      >
        {name}
      </p>
      {isRemovable && (
        <div className={styles.removeIconBox} onClick={remove}>
          <RemoveIcon
            className={styles.removeIcon}
            style={{
              fill: isColorLight(color) ? "#000000" : "#FFFFFF",
            }}
          />
        </div>
      )}
    </div>
  );
}

export { ProjectPortfolioTag };
